import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

export function useGroupTripFeatureFlag(): { enabled: boolean; isLoading: boolean } {
  const flagsQuery = usePublicFeatureFlags()
  return {
    enabled: flagsQuery.data?.find((row) => row.module_name === 'group-trip')?.enabled === true,
    isLoading: flagsQuery.isPending,
  }
}

export function useGroupTripEnabled(): boolean {
  return useGroupTripFeatureFlag().enabled
}
